//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { ITimeoutService } from 'angular';
import moment from 'moment-timezone';

import map from 'lodash/fp/map.js';

import template from './post-count-trend-graph.html';

import { CUSTOM_OPTIONS } from 'app/constants/highcharts-custom-options';

const dateFormat = 'M/D ddd';

export class PostCountTrendGraph {

  public data;

  public chartFormattedData;
  public chartCustomOptions;

  constructor(private $timeout: ITimeoutService) {
  }

  public $onChanges(changesObj) {
    if (changesObj.data) {
      this.updateData();
    }
  }

  private addReadableDates(data) {
    return map((datum: any) => {
      return Object.assign({ readableDate: moment(datum.timestamp).format(dateFormat) }, datum);
    })(data);
  }

  private updateData() {
    const completeData = this.addReadableDates(this.data);
    const xs = map((datum: any) => datum.readableDate)(completeData);
    const ys = map((datum: any) => datum.count)(completeData);
    const newData = {
      categories: xs,
      label: 'Post Count',
      series: ys,
    };

        // Highcharts + modified styles + static data = trouble
        // Since our Curalate chart configurations are applied based on a watcher applied to the data
        // we have to update the data reference for styles to apply properly
    this.$timeout(() => {
      this.chartCustomOptions = CUSTOM_OPTIONS();
      this.chartFormattedData = newData;
    });
  }
}

angular.module('curalate').component('postCountTrendGraph', {
  bindings: {
    data: '<',
  },
  controller: [
    '$timeout',
    PostCountTrendGraph,
  ],
  template,
});
